import { API_ROOT, fetchWithTimeout } from './v2Client';

// Dernière réponse reçue et son ETag : l'écran renvoie `If-None-Match` et l'API répond 304 (sans corps) tant
// que rien n'a changé — on resservira alors ce corps-ci. Sans ETag lisible (en-tête non exposé par CORS),
// le cache HTTP du navigateur fait la même revalidation de lui-même : on reçoit un 200 avec le corps en cache.
let lastEtag = '';
let lastSnapshot = null;

/**
 * GET /Season/screen_display_snapshot — présence + paires du jour (écrans salle).
 * Public / anonyme (TV) — pas de Bearer. `signal` : AbortController du composant (démontage).
 */
export async function fetchScreenDisplaySnapshot({ signal } = {}) {
  const root = String(API_ROOT || '').replace(/\/+$/, '');
  const headers = { Accept: 'application/json', 'Host-Environment': '.net' };
  if (lastEtag && lastSnapshot) headers['If-None-Match'] = lastEtag;
  const res = await fetchWithTimeout(`${root}/Season/screen_display_snapshot`, { signal, headers });
  if (res.status === 304 && lastSnapshot) return lastSnapshot;
  if (!res.ok) {
    const err = new Error(`screen_display_snapshot ${res.status}`);
    err.status = res.status;
    throw err;
  }
  const data = await res.json();
  const players = Array.isArray(data?.players) ? data.players : [];
  const todayPending = Array.isArray(data?.today_pending_matches)
    ? data.today_pending_matches
    : [];
  lastSnapshot = { players, todayPendingMatches: todayPending };
  lastEtag = res.headers.get('ETag') || '';
  return lastSnapshot;
}
